import React from "react";


const ApplicationBtnOut: React.FC = () => {

  return (
    <svg
      id="レイヤー_1"
      data-name="レイヤー 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 119.43906 119.44042"
    >
      <g id="グループ_348" data-name="グループ 348">
        <path
          id="パス_1971"
          data-name="パス 1971"
          d="M13.19053,97.16117a59.73292,59.73292,0,0,1,.041-74.933l.532-.659,3.566,2.881-.532.659a55.148,55.148,0,0,0-.038,69.176l.532.66-3.569,2.876Z"
          transform="translate(0.00003 0.00021)"
        />
        <path
          id="パス_1973"
          data-name="パス 1973"
          d="M102.1085,94.99118l.533-.66a55.15005,55.15005,0,0,0,.038-69.176l-.532-.66,3.569-2.876.532.66a59.733,59.733,0,0,1-.04,74.932l-.533.66Z"
          transform="translate(0.00003 0.00021)"
        />
        <path
          id="パス_1975"
          data-name="パス 1975"
          d="M94.33152,16.79818a55.149,55.149,0,0,0-69.175-.038l-.66.532-2.877-3.569.66-.532a59.73,59.73,0,0,1,74.933.041l.65905.533-2.88,3.566Z"
          transform="translate(0.00003 0.00021)"
        />
        <path
          id="パス_1977"
          data-name="パス 1977"
          d="M59.68748,119.44018a59.85288,59.85288,0,0,1-37.46-13.232l-.66-.533,2.881-3.566.65906.532a55.148,55.148,0,0,0,69.176.038l.661-.532,2.875,3.57-.66.532a59.85713,59.85713,0,0,1-37.442,13.191Z"
          transform="translate(0.00003 0.00021)"
        />
      </g>
    </svg>
  );
};

export default ApplicationBtnOut;
